import { z } from "zod";
import { RequirementSchema } from "./requirements.js";
import { SpecSnapshotSchema } from "./spec.js";
import { ApartmentTakeoffRowSchema } from "./takeoff.js";
import { IdSchema, IsoTimestampSchema, NonEmptyStringSchema, NonNegativeIntegerSchema, SourceRefSchema, StorageRefSchema, UnknownRecordSchema } from "./source.js";
export const BenchmarkInputSchema = z
    .object({
    id: IdSchema,
    sources: z.array(SourceRefSchema).min(1),
    takeoffRows: z.array(ApartmentTakeoffRowSchema),
    requirements: z.array(RequirementSchema),
    attachments: z.array(StorageRefSchema),
    notes: z.array(NonEmptyStringSchema),
    metadata: UnknownRecordSchema
})
    .strict();
export const BenchmarkGoldenSpecSchema = z
    .object({
    id: IdSchema,
    apartmentTypeComparisonMode: z.literal("aggregate").optional(),
    specSnapshot: SpecSnapshotSchema,
    authority: z.enum([
        "rich_worked_example",
        "delivered_project",
        "curated_legacy",
        "negative_invariant"
    ]),
    sourceRefs: z.array(SourceRefSchema).min(1),
    notes: z.array(NonEmptyStringSchema),
    deferredExpectations: UnknownRecordSchema.optional()
})
    .strict();
export const BenchmarkScoringPolicySchema = z
    .object({
    id: IdSchema,
    name: NonEmptyStringSchema,
    version: NonEmptyStringSchema,
    hardInvariantKeys: z.array(NonEmptyStringSchema),
    weightedDimensions: z.record(NonEmptyStringSchema, z.number().nonnegative()),
    deferredDimensions: z.record(NonEmptyStringSchema, NonEmptyStringSchema).optional(),
    passThreshold: z.number().min(0).max(1),
    sourceRefs: z.array(SourceRefSchema).min(1)
})
    .strict();
export const BenchmarkCaseSchema = z
    .object({
    id: IdSchema,
    orgId: IdSchema,
    version: NonEmptyStringSchema,
    title: NonEmptyStringSchema,
    tier: z.enum(["seed", "high_value", "medium_value", "low_value"]),
    tags: z.array(NonEmptyStringSchema),
    input: BenchmarkInputSchema,
    goldenSpec: BenchmarkGoldenSpecSchema.optional(),
    scoringPolicyId: IdSchema,
    status: z.enum(["draft", "active", "superseded", "disabled"]),
    sourceRefs: z.array(SourceRefSchema).min(1),
    createdAt: IsoTimestampSchema
})
    .strict();
export const BenchmarkScorecardSchema = z
    .object({
    id: IdSchema,
    benchmarkCaseId: IdSchema,
    score: z.number().min(0).max(1),
    passed: z.boolean(),
    hardInvariantFailures: z.array(NonEmptyStringSchema),
    dimensionScores: z.record(NonEmptyStringSchema, z.number().min(0).max(1)),
    riskRefs: z.array(IdSchema),
    summary: NonEmptyStringSchema
})
    .strict();
export const BenchmarkRunSchema = z
    .object({
    id: IdSchema,
    orgId: IdSchema,
    version: NonEmptyStringSchema,
    benchmarkCaseIds: z.array(IdSchema),
    scoringPolicyId: IdSchema,
    specRunIds: z.array(IdSchema),
    status: z.enum(["queued", "running", "passed", "failed", "cancelled"]),
    scorecards: z.array(BenchmarkScorecardSchema),
    passedCount: NonNegativeIntegerSchema,
    failedCount: NonNegativeIntegerSchema,
    startedAt: IsoTimestampSchema,
    completedAt: IsoTimestampSchema.optional()
})
    .strict();
//# sourceMappingURL=validation.js.map